import { useCallback } from "react";

import type { GuestPageVisibilitySettingsInput, PlainSettingInput } from "@/lib/gql/__generated__/graphql";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { START_GUIDE_QUERY } from "@/components/features/_shared/repository/start-guide/query/schema";

import * as Query from "../query";
import { PLAIN_SETTING_FOR_DESIGN_PLAIN_MUTATION } from "./schema";

export const usePlainSettingMutation = () => {
	const { mutationFunc } = useCustomMutation(PLAIN_SETTING_FOR_DESIGN_PLAIN_MUTATION);

	const onUpdatePlainSetting = useCallback(
		async (
			input: PlainSettingInput,
			guestPageVisibilitySettingsVariables: {
				guestPageVisibilitySettingsInput: GuestPageVisibilitySettingsInput;
				shouldUpdateGuestPageVisibility: boolean;
			},
		) => {
			return mutationFunc({
				variables: { input, ...guestPageVisibilitySettingsVariables },
				refetchQueries: [
					{
						query: Query.PLAIN_SETTING_FOR_DESIGN_PLAIN_QUERY,
						variables: { hotelID: input.hotelID },
					},
					{
						query: START_GUIDE_QUERY,
						variables: { hotelID: input.hotelID },
					},
				],
			});
		},
		[mutationFunc],
	);

	return {
		onUpdatePlainSetting,
	};
};
